import {WebviewMessage, WebviewMessagePayload} from '@udemy/shared-utils';

// Enum that registers supported events
const enum WebviewEvents {
    ON_KEEP_SHOPPING = 'onKeepShopping',
}

export class OnKeepShoppingMessage implements WebviewMessage<WebviewMessagePayload> {
    methodName = WebviewEvents.ON_KEEP_SHOPPING;
    payload = {toJSON: () => '{}'};
}
